import { SHOW_TOAST, HIDE_TOAST } from './types';

export const initialState = {
	isVisible: false,
	title: '',
	msg: '',
	type: 'success',
};

function toast(state = initialState, action) {
	switch (action.type) {
		case SHOW_TOAST:
			return {
				...state,
				...action.payload,
				isVisible: true,
			};
		case HIDE_TOAST:
			return {
				...state,
				isVisible: false,
				title: '',
				msg: '',
				type: 'success',
			};
		default:
			return state;
	}
}

export default toast;
